/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { cssMap, jsx } from '@compiled/react';
import { useAtomValue } from 'jotai';
import { loadable } from 'jotai/utils';

import { selectAllMetrics } from '../../../../utils/orgMetrics';
import { Footer } from '../../../components/Footer';
import { LoadingView } from '../../../components/LoadingView';
import { GettingStartedSection } from '../../../components/Sections/GettingStartedSection';
import { CollaboratorsSection } from '../../../components/Sections/v2/CollaboratorsSection';
import { ConnectedAppsSection } from '../../../components/Sections/v2/ConnectedAppsSection';
import { GraphPreviewSection } from '../../../components/Sections/v2/GraphPreviewSection';
import { IntroductionSection } from '../../../components/Sections/v2/IntroductionSection';
import { UserGraphSection } from '../../../components/Sections/v2/UserGraphSection';
import { OrgMetricsAtom } from '../../../state';

const styles = cssMap({
	pageContainer: {
		// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
		backgroundColor: '#111213',
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		minHeight: '100vh',
		WebkitFontSmoothing: 'antialiased',
		MozOsxFontSmoothing: 'grayscale',
	},
});

const OrgMetricsLoadable = loadable(OrgMetricsAtom);

export function LoggedInViewV2(): JSX.Element {
	const loadableState = useAtomValue(OrgMetricsLoadable);

	if (loadableState.state === 'loading') {
		return <LoadingView />;
	}

	const metrics = loadableState.state === 'hasData' ? loadableState.data.data : null;
	const error = loadableState.state === 'hasData' ? loadableState.data.error : null;

	if (error) {
		// eslint-disable-next-line no-console
		console.warn('OrgMetricsSection: falling back to placeholder stats —', error);
	}

	const allMetrics = selectAllMetrics(metrics);

	return (
		<div css={styles.pageContainer}>
			<IntroductionSection metrics={allMetrics} />
			<GraphPreviewSection metrics={allMetrics} />
			<ConnectedAppsSection metrics={allMetrics} />
			<CollaboratorsSection metrics={allMetrics} />
			<UserGraphSection metrics={allMetrics} />
			<GettingStartedSection />
			<Footer />
		</div>
	);
}
